import { Clock, TrendingUp, Sparkles } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/Reveal";

const BLOCKS = [
  {
    icon: Clock,
    title: "Extend Playable Hours",
    body: "Make selected areas of a golf facility usable after sunset — greens, practice areas, and signature holes remain in play long after dusk.",
  },
  {
    icon: TrendingUp,
    title: "Unlock New Revenue Opportunities",
    body: "Create opportunities for evening tee times, events, and additional facility utilization — without fixed promises, grounded in your market.",
  },
  {
    icon: Sparkles,
    title: "Elevate the Experience",
    body: "Introduce a memorable nighttime golf experience members and guests talk about — a course that feels entirely new after dark.",
  },
];

export default function Opportunity() {
  return (
    <section className="py-24 sm:py-32 lg:py-40 px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto" data-testid="opportunity-section">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8">
        <div className="lg:col-span-5">
          <Reveal>
            <Eyebrow>Lighting Creates Opportunity</Eyebrow>
            <h2 className="font-display font-bold uppercase tracking-tight text-2xl sm:text-3xl lg:text-4xl leading-tight">
              More Hours.<br />More Possibilities.
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="mt-8 text-muted-green text-base sm:text-lg leading-relaxed max-w-md">
              Professionally designed lighting can help golf courses extend playable hours,
              introduce night golf, host evening events, and potentially create additional
              revenue opportunities — all on your terms, at your pace.
            </p>
          </Reveal>
        </div>

        <div className="lg:col-span-7 flex flex-col">
          {BLOCKS.map((b, i) => (
            <Reveal key={b.title} delay={i * 0.12}>
              <div
                className="group flex gap-6 sm:gap-8 py-8 sm:py-10 border-t hairline last:border-b items-start hover:bg-white/[0.02] transition-colors duration-500 px-2 sm:px-4"
                data-testid={`opportunity-block-${i + 1}`}
              >
                <span className="font-mono-tech text-xs text-white/30 pt-1.5">0{i + 1}</span>
                <b.icon size={22} className="text-[#A7D7A0] mt-1 shrink-0" strokeWidth={1.5} />
                <div>
                  <h3 className="font-display font-semibold text-xl sm:text-2xl tracking-tight group-hover:text-[#A7D7A0] transition-colors duration-500">
                    {b.title}
                  </h3>
                  <p className="mt-3 text-muted-green text-sm sm:text-base leading-relaxed max-w-lg">{b.body}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
